"use strict";
/**
 * Created by Ning Jiang on 3/21/2017.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SequentiallyBetWayInitialWPController = void 0;
const GameConfig_1 = require("../../../../core/gameconfig/GameConfig");
const SequentiallyInitialWPController_1 = require("./SequentiallyInitialWPController");
class SequentiallyBetWayInitialWPController extends SequentiallyInitialWPController_1.SequentiallyInitialWPController {
    constructor(indexes, config = {
        name: "SequentiallyBetWayInitialWin",
        hasWinCountUp: true,
        skippable: true,
        tweakEnabled: true,
        betWinMode: 2 /* BetWinMode.BET_WAY */
    }) {
        super(indexes, config);
    }
    addSingleBetWinAnimationToTimeline(betWayWinData, timeline, startTime) {
        const reelsNum = betWayWinData.length;
        let symbol;
        let symbolDelay = 0;
        for (let i = 0; i < reelsNum; i++) {
            for (let j = 0; j < betWayWinData.reelWinPositions[i].length; j++) {
                if (betWayWinData.reelWinPositions[i][j]) {
                    symbol = this.findSymbol(i, j);
                    if (!symbol) {
                        debugger;
                        throw new Error(`Error: SequentiallyBetWayInitialWPController.playBetWinPresentation(): Cannot find symbol at reel ${i} symbol ${j}`);
                    }
                    symbolDelay += this.addSymbolWinAnimationToTimeline(betWayWinData, timeline, startTime + symbolDelay, symbol, i, j);
                    if (this._winSymbols.indexOf(symbol) === -1) {
                        this._winSymbols.push(symbol);
                    }
                }
            }
        }
        return this.getNextBetWinAnimationTimeOffset(symbolDelay);
    }
    // Returns the offset time in the main timeline from this symbol animation start to when the next symbol animation should start.
    addSymbolWinAnimationToTimeline(betWayWinData, timeline, startTime, symbol, reelId, symbolId) {
        const symbolAnimation = symbol.changeState({
            state: GameConfig_1.GameConfig.instance.SYMBOL_STATES.win,
            setStack: true,
            fadeInDuration: 0.1
        });
        timeline.add([
            () => this.sortSymbolDepthToTop(symbol),
            symbolAnimation
        ], startTime);
        return this.getNextSymbolAnimationTimeOffset(symbolAnimation.totalDuration());
    }
    sortSymbolDepthToTop(symbol) {
        if (symbol && symbol.parent) {
            symbol.parent.addChild(symbol);
        }
    }
    getNextBetWinAnimationTimeOffset(lastSymbolDelay) {
        return lastSymbolDelay;
    }
    getNextSymbolAnimationTimeOffset(duration) {
        return duration;
    }
}
exports.SequentiallyBetWayInitialWPController = SequentiallyBetWayInitialWPController;
//# sourceMappingURL=SequentiallyBetWayInitialWPController.js.map